export const decimalToHex = (hex) =>
    "#" + hex.toString(16);

export const hexToDecimal = (hex) =>
    parseInt(hex.replace("#", ''), 16);